var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.418 18.3031C5.39096 15.692 8.49873 14 11.9999 14C15.501 14 18.6087 15.692 20.5817 18.3031C20.5906 18.3149 20.5996 18.3268 20.6086 18.3386C20.7782 18.563 20.9601 18.8035 21.0901 19.0356C21.2474 19.3165 21.364 19.6414 21.3568 20.0366C21.351 20.3542 21.2548 20.6516 21.1379 20.8864C21.021 21.1212 20.8418 21.3772 20.5918 21.5734C20.2585 21.835 19.8956 21.9276 19.5732 21.9662C19.2904 22.0001 18.9552 22.0001 18.6182 22C18.603 22 18.5878 22 18.5726 22H5.42708C5.4119 22 5.39671 22 5.38152 22C5.04452 22.0001 4.70934 22.0001 4.42649 21.9662C4.10411 21.9276 3.7412 21.835 3.40787 21.5734C3.15793 21.3772 2.9787 21.1212 2.86183 20.8864C2.74495 20.6516 2.64871 20.3542 2.6429 20.0366C2.63567 19.6414 2.75228 19.3165 2.90961 19.0356C3.0396 18.8035 3.22149 18.563 3.39113 18.3386C3.40012 18.3268 3.40908 18.3149 3.418 18.3031Z",
    fill: "#462AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49985 7.5C6.49985 4.46243 8.96229 2 11.9999 2C15.0374 2 17.4999 4.46243 17.4999 7.5C17.4999 10.5376 15.0374 13 11.9999 13C8.96229 13 6.49985 10.5376 6.49985 7.5Z",
    fill: "#462AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeUserIcon);
export default __webpack_public_path__ + "static/media/change-user-icon.e4390fea4d3161790558610f5a33ba0e.svg";
export { ForwardRef as ReactComponent };